// 返回首页
export const backHome = () => {
  return new Promise(resolve => {
    window.PHK.webview.back({
      id: 'home'
    })
  })
}
// 分享微信
export const shareWx = ({ title, desc, url, image }) => {
  return new Promise(resolve => {
    window.PHK.thirdApp.wxPageShare({
      desc,
      image,
      title,
      type: '0',
      url
    })
  })
}
// 分享朋友圈
export const sharePYQ = ({ title, desc, url, image }) => {
  return new Promise(resolve => {
    window.PHK.thirdApp.wxPageShare({
      desc,
      image,
      title,
      type: '1',
      url
    })
  })
}
// 分享图片
export const sharePicture = ({ url = '' }) => {
  return new Promise(resolve => {
    window.PHK.thirdApp.wxImageShare(
      {
        image: url,
        scene: 'WXSceneSession' // WXSceneSession是分享到会话列表、WXSceneTimeline朋友圈
      }, (e) => {
        console.log('微信图片分享结果', e)
      })
  })
}
// 保存图片
export const saveAlbum = ({ jsonData = '', imgdata }) => {
  return new Promise((resolve, reject) => {
    window.PHK.thumbnailer.saveWebImageToAlbum(jsonData, imgdata, (e) => {
      console.log('保存图片成功', e)
    }, (e) => {
      console.log('保存图片失败', e)
    })
  })
}

// 复制到剪切板 (成功)
export const pasteText = (text) => {
  return new Promise(resolve => {
    window.PHK.storage.copy(text)
  })
}



// WEBPACK FOOTER //
// ./src/environment/lk_api.js